const MuiButton = (theme) => ({
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        borderRadius: 12,
        textTransform: 'none',
        fontWeight: 600,
        fontSize: '0.875rem',
        letterSpacing: '-0.01em',
        padding: '10px 20px',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-1px)',
        },
        '&:active': {
          transform: 'translateY(0)',
        },
      },
      contained: {
        boxShadow: '0 4px 14px 0 rgba(99, 102, 241, 0.4)',
        '&:hover': {
          boxShadow: '0 6px 20px 0 rgba(99, 102, 241, 0.5)',
        },
      },
      containedPrimary: {
        background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
        '&:hover': {
          background: 'linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)',
        },
      },
      containedSecondary: {
        background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
        '&:hover': {
          background: 'linear-gradient(135deg, #DB2777 0%, #EC4899 100%)',
        },
      },
      outlined: {
        borderWidth: '1.5px',
        '&:hover': {
          borderWidth: '1.5px',
        },
      },
      sizeLarge: {
        padding: '13px 28px',
        fontSize: '1rem',
        borderRadius: 14,
      },
      sizeSmall: {
        padding: '6px 14px',
        fontSize: '0.8125rem',
        borderRadius: 8,
      },
    },
  },
})

export default MuiButton
